import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Dropdown, Table, Modal, Button, Form, InputGroup, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Ttb = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [activeMenu, setActiveMenu] = useState('');
  const [time, setTime] = useState({ date: '', clock: '' });
  const location = useLocation();

  // Ref untuk mengarahkan kursor ke Nomor Surat Pesanan
  const noSpRef = useRef(null);

  // State Form Utama Header
  const [noSp, setNoSp] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [tglFaktur, setTglFaktur] = useState(new Date()); // State khusus Tanggal Faktur
  const [pemasok, setPemasok] = useState('');
  const [caraBayar, setCaraBayar] = useState('');
  const [tempo, setTempo] = useState('');
  const [noFaktur, setNoFaktur] = useState('');
  const [lastCheckedSp, setLastCheckedSp] = useState('');
  
  // ==========================================
  // STATE MANAGEMENT BARANG
  // ==========================================
  const [items, setItems] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [newItem, setNewItem] = useState({
    kode: '',
    nama: '',
    nie: '',
    batch: '',
    kfa: '',
    tglEd: new Date(),
    qty: 1,
    satuan: 'Box',
    priceList: 0,
    discPercent: 0,
    ppnPercent: 11
  });

  // ==========================================
  // STATE MANAGEMENT MODAL PENCARIAN BARANG (API)
  // ==========================================
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [searchError, setSearchError] = useState('');

  // Handler Buka & Tutup Modal Input
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setItemErrors({ qty: '', priceList: '' });
    setNewItem({
      kode: '',
      nama: '',
      nie: '',
      batch: '',
      kfa: '',
      tglEd: new Date(),
      qty: 1,
      satuan: 'Box',
      priceList: 0,
      discPercent: 0,
      ppnPercent: 11
    });
  };

  // Handler Buka & Tutup Modal Cari
  const handleOpenSearchModal = () => {
    setShowSearchModal(true);
    setSearchResults([]);
    setSearchKeyword('');
    setSearchError('');
  };
  const handleCloseSearchModal = () => setShowSearchModal(false);

  // ==========================================
  // HANDLER RESET / BERSIHKAN FORM
  // ==========================================
  const handleResetForm = () => {
    setNoSp('');
    setSelectedDate(new Date());
    setTglFaktur(new Date());
    setPemasok('');
    setCaraBayar('Tunai');
    setTempo('');
    setNoFaktur('');
    setItems([]);
    setDiscTunai(0);

    // Fokuskan kursor kembali ke input Nomor Surat Pesanan
    if (noSpRef.current) {
      noSpRef.current.focus();
    }
  };

  // ==========================================
  // HANDLER FETCH DATA BARANG (URL PUBLIC)
  // ==========================================
  const handleSearchBarang = async (e) => {
    if (e) e.preventDefault();
    if (!searchKeyword.trim()) return;

    setIsLoadingSearch(true);
    setSearchError('');

    try {
      const publicUrl = localStorage.getItem('apiUrl') || localStorage.getItem('baseUrl') || process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('token');

      const endpoint = `${publicUrl}/show_barang?kdbrg=${encodeURIComponent(searchKeyword.trim())}&token=${encodeURIComponent(token)}`;
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result && result.data) {
        setSearchResults(result.data);
      } else if (Array.isArray(result)) {
        setSearchResults(result);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("Error fetching barang:", err);
      setSearchError("Gagal mengambil data barang dari server.");
      setSearchResults([]);
    } finally {
      setIsLoadingSearch(false);
    }
  };
  // Ref untuk penanganan fokus kursor pada modal input barang
  const qtyRef = useRef(null);
  const priceListRef = useRef(null);

  // State inline validation errors
  const [itemErrors, setItemErrors] = useState({ qty: '', priceList: '' });

  // Handler Memilih Barang dari Modal Pencarian
  const handleSelectBarang = (selected) => {
    setNewItem(prev => ({
      ...prev,
      kode: selected.kode,
      nama: selected.nama,
      nie: selected.nie || prev.nie,
      satuan: selected.satuan || prev.satuan
    }));
    handleCloseSearchModal();
  };

  // Handler Input Modal Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handler Simpan Data dari Modal ke Tabel
  const handleSaveItem = (e) => {
    e.preventDefault();

    const qty = parseFloat(newItem.qty);
    const priceList = parseFloat(newItem.priceList);
    const errors = { qty: '', priceList: '' };
    let hasError = false;

    // 1. Validasi Qty
    if (!newItem.qty || isNaN(qty) || qty <= 0) {
      errors.qty = 'Qty tidak boleh kosong atau 0!';
      hasError = true;
    }

    // 2. Validasi Price List
    if (!newItem.priceList || isNaN(priceList) || priceList <= 0) {
      errors.priceList = 'Price List tidak boleh kosong atau 0!';
      hasError = true;
    }

    setItemErrors(errors);

    if (hasError) {
      if (errors.qty && qtyRef.current) {
        setTimeout(() => qtyRef.current.focus(), 50);
      } else if (errors.priceList && priceListRef.current) {
        setTimeout(() => priceListRef.current.focus(), 50);
      }
      return;
    }

    const discPercent = parseFloat(newItem.discPercent) || 0;
    const ppnPercent = parseFloat(newItem.ppnPercent) || 0;

    const discRp = (priceList * discPercent) / 100;
    const hrgJadi = priceList - discRp;
    const ppnRp = (hrgJadi * ppnPercent) / 100;
    const hrgNett = hrgJadi + ppnRp;

    const itemData = {
      id: Date.now(),
      kode: newItem.kode || '-',
      nama: newItem.nama || '-',
      nie: newItem.nie || '-',
      batch: newItem.batch || '-',
      kfa: newItem.kfa || '-',
      tglEd: newItem.tglEd ? newItem.tglEd.toLocaleDateString('id-ID') : '-',
      qty: qty,
      satuan: newItem.satuan,
      priceList: priceList,
      discPercent: discPercent,
      discRp: discRp,
      hrgJadi: hrgJadi,
      ppnPercent: ppnPercent,
      ppnRp: ppnRp,
      hrgNett: hrgNett
    };

    setItems(prev => [...prev, itemData]);
    handleCloseModal();
  };
  // Handler Hapus Item
  const handleDeleteItem = (id) => {
    setItems(prev => prev.filter(item => item.id !== id));
  };

  // Kalkulasi Footer Total
  const subTotal = items.reduce((acc, curr) => acc + (curr.hrgNett * curr.qty), 0);
  const totalDiscount = items.reduce((acc, curr) => acc + (curr.discRp * curr.qty), 0);
  const [discTunai, setDiscTunai] = useState(0);
  const grandTotal = subTotal - (parseFloat(discTunai) || 0);

  // ==========================================
  // STATE SIMPAN TTB
  // ==========================================
  const [isSaving, setIsSaving] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [saveLog, setSaveLog] = useState({ success: 0, failed: 0, errors: [] });

  // ==========================================
  // HANDLER SIMPAN TTB KE DATABASE
  // ==========================================
  const handleSimpanTtb = async () => {
    // Validasi header
    if (!noSp.trim()) {
      setAlertMessage('Nomor Surat Pesanan (SP) wajib diisi sebelum menyimpan!');
      setShowAlertModal(true);
      return;
    }
    if (!noFaktur.trim()) {
      setAlertMessage('Nomor Faktur wajib diisi sebelum menyimpan!');
      setShowAlertModal(true);
      return;
    }
    if (items.length === 0) {
      setAlertMessage('Tabel barang masih kosong! Tambahkan minimal 1 barang sebelum menyimpan.');
      setShowAlertModal(true);
      return;
    }

    setIsSaving(true);
    const apiUrl = localStorage.getItem('apiUrl') || process.env.REACT_APP_API_URL || 'http://localhost:8000';
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId') || localStorage.getItem('user') || '';
    const xid = localStorage.getItem('xid') || localStorage.getItem('lokasi') || '';
    const mlevel = parseInt(localStorage.getItem('level') || '0');

    // Format tanggal ke dd/mm/yyyy
    const formatTgl = (dateObj) => {
      if (!dateObj) return '';
      const d = new Date(dateObj);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    };

    const tglFakturStr = formatTgl(tglFaktur);
    const tglPesanStr  = formatTgl(selectedDate);

    let successCount = 0;
    let failedCount  = 0;
    const errors     = [];

    for (const item of items) {
      try {
        const payload = {
          // ── HEADER ──────────────────────────────────
          kdobat    : item.kode  || '',
          kdsuplier : pemasok   || '',
          xid       : xid,
          user_id   : userId,
          mlevel    : mlevel,
          nooph     : noSp,
          faktur    : noFaktur,
          po        : noSp,
          suplier   : pemasok   || '',
          tempo     : tempo     || '',
          tglfaktur : tglFakturStr,
          tglpesan  : tglPesanStr,
          disctunai : parseFloat(discTunai) || 0,

          // ── DETAIL BARANG ────────────────────────────
          batch      : item.batch     !== '-' ? item.batch     : '',
          tglexpired : item.tglEd     !== '-' ? item.tglEd     : '',
          nmobat     : item.nama      || '',
          satuan2    : item.satuan    || '',   // satuan beli
          satuan1    : item.satuan    || '',   // satuan jual (sama)
          kdsatuan1  : item.satuan    || '',
          kdsatuan2  : item.satuan    || '',
          disc2      : item.discPercent || 0,
          nospulang  : '',
          xtotbeli   : item.qty       || 0,

          // ── HARGA ───────────────────────────────────
          harga      : item.priceList || 0,   // pricelist
          qty        : item.qty       || 0,   // qty beli
          qty2       : 1,                     // konversi (default 1)
          harga2     : item.priceList || 0,   // harga beli per satuan
          harsat     : item.hrgJadi   || 0,   // harga satuan jadi
          discrp2    : item.discRp    || 0,
          ppn2       : item.ppnPercent || 0,
          Ppn3       : item.ppnRp     || 0,
          TotHarga2  : item.hrgNett   || 0,

          token      : token,
        };

        const response = await fetch(`${apiUrl}/simpan_ttb`, {
          method : 'POST',
          headers: { 'Content-Type': 'application/json' },
          body   : JSON.stringify(payload),
        });

        const result = await response.json();
        if (response.ok && result.status === 'success') {
          successCount++;
        } else {
          failedCount++;
          errors.push(`${item.nama}: ${result.message || 'Gagal disimpan'}`);
        }
      } catch (err) {
        failedCount++;
        errors.push(`${item.nama}: ${err.message}`);
      }
    }

    setIsSaving(false);
    setSaveLog({ success: successCount, failed: failedCount, errors });
    setShowSaveModal(true);

    // Jika semua berhasil, reset form
    if (failedCount === 0) {
      handleResetForm();
    }
  };
  
  // ==========================================
  // HANDLER PENGECEKAN SP (URL PUBLIC & FETCH)
  // ==========================================
  const handleCekSp = async (spNumber) => {
    const cleanSp = spNumber ? spNumber.trim() : '';

    if (!cleanSp || cleanSp === lastCheckedSp) return;

    setLastCheckedSp(cleanSp);

    try {
      const publicUrl = localStorage.getItem('apiUrl') || localStorage.getItem('baseUrl') || process.env.REACT_APP_API_URL || '';
      const token = localStorage.getItem('token');

      const endpoint = `${publicUrl}/ceksp?nosp=${encodeURIComponent(cleanSp)}`;
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP Error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.status === 1) {
        if (data.nmsuplier) setPemasok(data.nmsuplier);
        if (data.carabayar) setCaraBayar(data.carabayar);
        if (data.tempo !== undefined) setTempo(`${data.tempo} Hari`);

        if (data.tglpesan) {
          const parts = data.tglpesan.split('/');
          if (parts.length === 3) {
            const dateObj = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
            setSelectedDate(dateObj);
          }
        }

        setHasAlertedNoSp(false);
      } else {
        setAlertMessage('Nomor Surat Pesanan tidak ditemukan!');
        setNoSp('');
        setShowAlertModal(true);
      }
    } catch (err) {
      console.error("Error checking SP:", err);
      setAlertMessage('Gagal mengambil data Surat Pesanan dari server.');
      setShowAlertModal(true);
    }
  };

  const handleNoSpBlur = () => {
    if (noSp.trim()) {
      handleCekSp(noSp);
    }
  };

  const handleNoSpKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (noSp.trim()) {
        handleCekSp(noSp);
      }
    }
  };

  // ==========================================
  // EFFECT & HELPER FUNCTIONS
  // ==========================================
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);

    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      const parsedMenu = JSON.parse(savedMenu);
      setMenus(parsedMenu);
      if (parsedMenu.length > 0) {
        setActiveMenu(parsedMenu[0].id_mn);
      }
    }

    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };

    if (noSpRef.current) {
      noSpRef.current.focus();
    }
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const getMenuIcon = (menuName) => {
    switch (menuName.toUpperCase()) {
      case 'MASTER': return 'bi-folder2-open';
      case 'GUDANG': return 'bi-box-seam';
      case 'ADM GUDANG': return 'bi-building-gear';
      case 'APOTEKER': return 'bi-prescription2';
      case 'ADMINISTRATOR': return 'bi-person-workspace';
      case 'SETTING': return 'bi-sliders';
      default: return 'bi-grid-1x2';
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const handleNoSpChange = (e) => {
    const val = e.target.value;
    setNoSp(val);
    if (val.trim() !== '') {
      setHasAlertedNoSp(false);
    }
  };

  const handleNoFakturFocus = () => {
    if (!noSp.trim() && !hasAlertedNoSp) {
      setHasAlertedNoSp(true);
      setAlertMessage('Silakan isi Nomor Surat Pesanan (SP) terlebih dahulu!');
      setShowAlertModal(true);
    }
  };

  const handleNoFakturChange = (e) => {
    const val = e.target.value;
    if (!noSp.trim()) {
      if (!hasAlertedNoSp) {
        setHasAlertedNoSp(true);
        setAlertMessage('Silakan isi Nomor Surat Pesanan (SP) terlebih dahulu!');
        setShowAlertModal(true);
      }
      return;
    }
    setNoFaktur(val);
  };

  const handleCloseAlertModal = () => {
    setShowAlertModal(false);

    setTimeout(() => {
      if (noSpRef.current) {
        noSpRef.current.focus();
      }
    }, 100);
  };

  const [hasAlertedNoSp, setHasAlertedNoSp] = useState(false);
  const formatRupiah = (num) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(num || 0);
  };

  const CustomDateInput = React.forwardRef(({ value, onClick, style }, ref) => (
    <div className="input-group input-group-sm" onClick={onClick} ref={ref} style={{ cursor: 'pointer' }}>
      <input
        type="text"
        className="form-control"
        value={value}
        readOnly
        style={{
          ...style,
          borderRight: 'none',
          backgroundColor: '#fff',
          cursor: 'pointer'
        }}
      />
      <span 
        className="input-group-text bg-white text-muted" 
        style={{ 
          borderColor: '#cbd5e1', 
          borderLeft: 'none',
          fontSize: '0.75rem'
        }}
      >
        <i className="bi bi-calendar3 text-primary"></i>
      </span>
    </div>
  ));

  return (
    <div style={styles.appContainer}>
      {/* Navbar */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home">
            <i className="bi bi-layers-half me-2 text-warning"></i>
            <span className="fw-bold text-white">Solusi Integrasi Layanan Kesehatan ( SILK )</span>
          </a>
          
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-2">
              {menus.map((item) => {
                const isActive = location.pathname === item.lnk;
                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a 
                      className={`nav-link-custom ${isActive ? 'active' : ''}`} 
                      href={`#${item.des_mn.toLowerCase().replace(/\s+/g, '-')}`}
                      onClick={() => setActiveMenu(item.id_mn)}
                      style={{
                        ...styles.navLinkCustom,
                        ...(isActive ? styles.navLinkActive : {})
                      }}
                    >
                      <i className={`bi ${getMenuIcon(item.des_mn)}`}></i>
                      {item.des_mn.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
              <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
                <div className="fw-semibold" style={{ fontSize: '0.8rem' }}>{time.date}</div>
                <div className="text-warning" style={{ fontSize: '0.7rem' }}>{time.clock}</div>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle 
                  as="div" 
                  role="button"
                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-3 custom-profile-toggle"
                  style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                >
                  <div 
                    className="d-flex align-items-center justify-content-center bg-warning text-dark fw-bold rounded-circle shadow-sm"
                    style={{ width: '32px', height: '32px', fontSize: '0.85rem' }}
                  >
                    {username ? username.charAt(0).toUpperCase() : 'A'}
                  </div>
                  
                  <div className="d-none d-md-block text-start">
                    <div className="text-white fw-semibold lh-1" style={{ fontSize: '0.85rem' }}>{username}</div>
                    <div className="text-white-50 mt-1" style={{ fontSize: '0.7rem' }}>Online</div>
                  </div>
                  <i className="bi bi-chevron-down text-white-50 ms-1 small"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow border-0 mt-2 py-2 style-dropdown-menu" style={{ minWidth: '180px', borderRadius: '10px' }}>
                  <Dropdown.Item onClick={handleLogout} className="py-2 text-danger small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-box-arrow-right"></i> Keluar Aplikasi
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </nav>

      {/* Main Content */}
      <div style={styles.mainContent} className="p-2">
        <Row className="g-3 flex-grow-0">
          <Col xl={12} lg={12} md={12}>
            <Card style={styles.mainCard} className="border-0 shadow-sm">
              
              {/* Header Action Bar */}
              <div 
                style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} 
                className="d-flex flex-wrap justify-content-between align-items-center px-3 py-2 border-bottom"
              >
                <div className="d-flex align-items-center gap-2 my-1">
                  <span className="fw-bold tracking-wide text-white" style={{ fontSize: '0.88rem', letterSpacing: '0.3px' }}>
                    TANDA TERIMA BARANG (TTB)
                  </span>
                  {location.state?.info && (
                    <span style={{
                      fontSize: '0.68rem',
                      fontWeight: 400,
                      color: 'rgba(255,255,255,0.75)',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '20px',
                      padding: '1px 10px',
                      letterSpacing: '0.2px'
                    }}>
                      <i className="bi bi-info-circle me-1"></i>{location.state.info}
                    </span>
                  )}
                </div>

                <div className="d-flex align-items-center gap-2 my-1">
                  <div className="btn-group shadow-sm" role="group">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm d-inline-flex align-items-center gap-2 fw-semibold px-2.5"
                      onClick={handleSimpanTtb}
                      disabled={isSaving || items.length === 0}
                      style={{ fontSize: '0.75rem', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.4)' }}
                    >
                      {isSaving ? (
                        <><Spinner animation="border" size="sm" /> <span>Menyimpan...</span></>
                      ) : (
                        <><i className="bi bi-check2-circle"></i><span>Proses</span></>
                      )}
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1.5 fw-semibold px-2.5 shadow-sm"
                      style={{ fontSize: '0.75rem', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.4)' }}
                    >
                      <i className="bi bi-printer text-primary"></i>
                      <span>Cetak Ulang</span>
                    </button>

                    {/* TOMBOL BERSIHKAN */}
                    <button
                      type="button"
                      className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1.5 fw-semibold px-2.5 shadow-sm"
                      onClick={handleResetForm}
                      style={{ fontSize: '0.75rem', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.4)' }}
                    >
                      <i className="bi bi-arrow-counterclockwise text-warning"></i>
                      <span>Bersihkan</span>
                    </button>
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1.5 fw-semibold px-2.5 shadow-sm"
                    onClick={() => navigate('/home')}
                    style={{ fontSize: '0.75rem', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.4)' }}
                  >
                    <i className="bi bi-house-door"></i>
                    <span>Home</span>
                  </button>
                </div>
              </div>

              {/* Form Body */}
              <Card.Body style={styles.cardBody}>
                <Row className="g-2 mb-2">
                  <Col xl={3} md={6}>
                    <label style={formStyles.formLabel}>
                      Nomor Surat Pesanan (SP)<span style={formStyles.requiredStar}>*</span>
                    </label>
                    <input 
                      ref={noSpRef}
                      type="text" 
                      className="form-control form-control-sm" 
                      style={formStyles.formControl} 
                      value={noSp}
                      onChange={handleNoSpChange}
                      onBlur={handleNoSpBlur}
                      onKeyDown={handleNoSpKeyDown}
                      placeholder="Ketik No SP lalu tekan Enter / Tab"
                    />
                  </Col>
                    
                  <Col xl={1} md={3} style={{ position: 'relative', zIndex: 10 }}>
                    <label style={formStyles.formLabel}>Tanggal</label>
                    <div className="input-group input-group-sm w-100 shadow-sm" style={{ borderRadius: '5px' }}>
                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat="dd/MM/yyyy"
                        wrapperClassName="w-100"
                        popperClassName="custom-datepicker-popper"
                        customInput={<CustomDateInput style={formStyles.formControl} />}
                      />
                    </div>
                  </Col>                    
                  
                  <Col xl={3} md={3}>
                    <label style={formStyles.formLabel}>Pemasok</label>
                    <input 
                      type="text" 
                      className="form-control form-control-sm" 
                      style={formStyles.formControl} 
                      value={pemasok}
                      onChange={(e) => setPemasok(e.target.value)} readOnly
                    />
                  </Col>

                  <Col xl={1} md={6}>
                    <label style={formStyles.formLabel}>Cara Bayar</label>
                    <select 
                      className="form-select form-select-sm" 
                      style={formStyles.formSelect}
                      value={caraBayar}
                      onChange={(e) => setCaraBayar(e.target.value)}
                    >
                      <option value="Tunai">Tunai</option>
                      <option value="Non Tunai">Non Tunai</option>
                    </select>
                  </Col>

                  <Col xl={1} md={6}>
                    <label style={formStyles.formLabel}>Tempo</label>
                    <input 
                      type="text" 
                      className="form-control form-control-sm" 
                      style={formStyles.formControl} 
                      value={tempo}
                      onChange={(e) => setTempo(e.target.value)}
                    />
                  </Col>

                  <Col xl={2} md={6}>
                    <label style={formStyles.formLabel}>No Faktur</label>
                    <input 
                      type="text" 
                      className="form-control form-control-sm" 
                      style={formStyles.formControl} 
                      value={noFaktur}
                      onFocus={handleNoFakturFocus}
                      onChange={handleNoFakturChange}
                    />
                  </Col>

                  <Col xl={1} md={6} style={{ position: 'relative', zIndex: 10 }}>
                    <label style={formStyles.formLabel}>Tanggal Faktur</label>
                    <div className="input-group input-group-sm w-100 shadow-sm" style={{ borderRadius: '5px' }}>
                      <DatePicker
                        selected={tglFaktur}
                        onChange={(date) => setTglFaktur(date)}
                        dateFormat="dd/MM/yyyy"
                        wrapperClassName="w-100"
                        popperClassName="custom-datepicker-popper"
                        popperPlacement="bottom-end"
                        popperProps={{
                          strategy: 'fixed'
                        }}
                        customInput={<CustomDateInput style={formStyles.formControl} />}
                      />
                    </div>
                  </Col>
                </Row>

                {/* Section Table & Footer */}
                <Row className="g-3 my-1 flex-grow-1">
                  <Col lg={12} md={12}>
                    <div className="rounded-3 border overflow-hidden shadow-sm bg-white">
                      {/* HEADER DETIL PENERIMAAN BARANG DENGAN TOMBOL TAMBAH BARANG */}
                      <div className="d-flex align-items-center justify-content-between px-3 py-2.5 border-bottom" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                        <div className="fw-bold text-white d-flex align-items-center gap-2" style={{ fontSize: '0.82rem', letterSpacing: '0.5px' }}>
                          <span className="p-1 rounded-2 d-inline-flex align-items-center justify-content-center" style={{ background: 'rgba(56, 189, 248, 0.15)', color: '#38bdf8' }}>
                            <i className="bi bi-box-seam-fill fs-6"></i>
                          </span>
                          <span>DETIL PENERIMAAN BARANG</span>
                        </div>
                        
                        <div className="d-flex align-items-center gap-2">
                          <span className="badge rounded-pill fw-normal px-2.5 py-1.5" style={{ background: 'rgba(255, 255, 255, 0.08)', color: '#94a3b8', border: '1px solid rgba(255, 255, 255, 0.12)', fontSize: '0.7rem' }}>
                            <i className="bi bi-layers me-1 text-info"></i>
                            {items.length} Item Diterima
                          </span>
                          
                          {/* TOMBOL TAMBAH BARANG */}
                          <button
                            type="button"
                            className="btn btn-sm d-inline-flex align-items-center gap-1.5 fw-bold px-3 py-1.5 shadow-sm text-white border-0"
                            onClick={handleOpenModal}
                            disabled={!noSp.trim() || !noFaktur.trim()}
                            style={{
                              fontSize: '0.73rem',
                              borderRadius: '6px',
                              background: (!noSp.trim() || !noFaktur.trim()) 
                                ? '#475569' 
                                : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                              boxShadow: (!noSp.trim() || !noFaktur.trim()) ? 'none' : '0 2px 8px rgba(16, 185, 129, 0.35)',
                              cursor: (!noSp.trim() || !noFaktur.trim()) ? 'not-allowed' : 'pointer'
                            }}
                          >
                            <i className="bi bi-plus-circle-fill fs-6"></i>
                            <span>Tambah Barang</span>
                          </button>
                        </div>
                      </div>

                      {/* Area Tabel */}
                      <div className="table-responsive shadow-sm border border-top-0 rounded-bottom" style={{ maxHeight: '300px' }}>
                        <Table hover size="sm" className="align-middle mb-0 custom-ttb-table" style={{ fontSize: '0.75rem' }}>
                          <thead className="sticky-top" style={{ zIndex: 1 }}>
                            {/* Baris Group Header Level 1 (Terang & Cerah) */}
                            <tr className="text-uppercase fw-bold text-white border-bottom" style={{ fontSize: '0.68rem', letterSpacing: '0.8px' }}>
                              <th colSpan={6} className="text-center py-1.5 border-end border-white border-opacity-30 shadow-sm" style={{ background: 'linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)' }}>
                                <i className="bi bi-shield-check me-1"></i> BARANG | AKSP
                              </th>
                              <th colSpan={10} className="text-center py-1.5 shadow-sm" style={{ background: 'linear-gradient(90deg, #059669 0%, #10b981 100%)' }}>
                                <i className="bi bi-cart-check me-1"></i> DATA PEMBELIAN
                              </th>
                            </tr>
                            {/* Baris Column Names Level 2 (Background Terang & Teks Kontras Tinggi) */}
                            <tr className="border-bottom align-middle" style={{ backgroundColor: '#e2e8f0', color: '#0f172a', fontSize: '0.72rem', letterSpacing: '0.3px', borderBottom: '2px solid #cbd5e1' }}>
                              <th className="text-start px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Kode</th>
                              <th className="text-start px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Nama Barang</th>
                              <th className="text-start px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>NIE</th>
                              <th className="text-start px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Batch No.</th>
                              <th className="text-center px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>KFA</th>
                              <th className="text-center px-2 py-2 border-end border-secondary border-opacity-30" style={{ color: '#0f172a', fontWeight: 700 }}>Tgl ED</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Qty</th>
                              <th className="text-start px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Satuan</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Tot. Pricelist</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Disc (%)</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Disc (Rp)</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>Hrg Jadi</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>PPN Masukan</th>
                              <th className="text-end px-2 py-2" style={{ color: '#047857', fontWeight: 800 }}>Hrg Nett</th>
                              <th className="text-end px-2 py-2" style={{ color: '#0f172a', fontWeight: 700 }}>PPN (Rp)</th>
                              <th className="text-center px-2 py-2" style={{ width: '40px', color: '#0f172a', fontWeight: 700 }}>#</th>
                            </tr>
                          </thead>
                          
                          <tbody>
                            {items.length === 0 ? (
                              <tr>
                                <td colSpan={16} className="text-center py-3 text-muted">
                                  Belum ada data barang. Klik tombol <strong>Tambah Barang</strong> di atas.
                                </td>
                              </tr>
                            ) : (
                              items.map((item) => (
                                <tr key={item.id}>
                                  <td className="px-2 font-monospace text-muted">{item.kode}</td>
                                  <td className="px-2 fw-semibold text-dark">{item.nama}</td>
                                  <td className="px-2 font-monospace">{item.nie}</td>
                                  <td className="px-2 font-monospace">{item.batch}</td>
                                  <td className="px-2 text-center font-monospace">{item.kfa}</td>
                                  <td className="px-2 text-center border-end">{item.tglEd}</td>
                                  <td className="px-2 text-end fw-semibold">{item.qty}</td>
                                  <td className="px-2 text-muted">{item.satuan}</td>
                                  <td className="px-2 text-end">{formatRupiah(item.priceList)}</td>
                                  <td className="px-2 text-end text-danger">{item.discPercent}%</td>
                                  <td className="px-2 text-end">{formatRupiah(item.discRp)}</td>
                                  <td className="px-2 text-end">{formatRupiah(item.hrgJadi)}</td>
                                  <td className="px-2 text-end">{formatRupiah(item.ppnRp)}</td>
                                  <td className="px-2 text-end fw-semibold text-success">{formatRupiah(item.hrgNett)}</td>
                                  <td className="px-2 text-end">{formatRupiah(item.ppnRp)}</td>
                                  <td className="px-2 text-center">
                                    <button 
                                      type="button" 
                                      className="btn btn-link text-danger p-0 border-0 shadow-none"
                                      onClick={() => handleDeleteItem(item.id)}
                                    >
                                      <i className="bi bi-trash3-fill"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>

                  {/* Footer Totals */}
                  <Col lg={12} className="mt-3">
                    <Row className="justify-content-end align-items-center g-2">
                      <Col xl={5} lg={6} md={8}>
                        <div className="p-3 rounded-3 border bg-light shadow-sm">
                          <div className="d-flex align-items-center justify-content-between mb-1.5">
                            <label style={formStyles.formLabel} className="mb-0 text-muted">Sub Total</label>
                            <input 
                              type="text" 
                              className="form-control form-control-sm text-end fw-semibold text-dark" 
                              style={{ ...formStyles.formControl, width: '180px' }} 
                              value={formatRupiah(subTotal)} 
                              readOnly 
                            />
                          </div>

                          <div className="d-flex align-items-center justify-content-between mb-1.5">
                            <label style={formStyles.formLabel} className="mb-0 text-muted">Total Discount</label>
                            <input 
                              type="text" 
                              className="form-control form-control-sm text-end fw-semibold text-danger" 
                              style={{ ...formStyles.formControl, width: '180px' }} 
                              value={formatRupiah(totalDiscount)} 
                              readOnly 
                            />
                          </div>

                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <label style={formStyles.formLabel} className="mb-0 text-muted">Discount Tunai</label>
                            <input 
                              type="number" 
                              className="form-control form-control-sm text-end fw-semibold text-danger" 
                              style={{ ...formStyles.formControl, width: '180px' }} 
                              value={discTunai}
                              onChange={(e) => setDiscTunai(e.target.value)}
                            />
                          </div>

                          <hr className="my-2 border-secondary opacity-25" />

                          <div className="d-flex align-items-center justify-content-between">
                            <label className="fw-bold text-primary mb-0" style={{ fontSize: '0.82rem' }}>GRAND TOTAL</label>
                            <input 
                              type="text" 
                              className="form-control form-control-sm text-end fw-bold text-primary bg-white" 
                              style={{ ...formStyles.formControl, width: '180px', fontSize: '0.85rem' }} 
                              value={formatRupiah(grandTotal)} 
                              readOnly 
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </div>

      {/* MODAL PERINGATAN / ALERT BOOTSTRAP */}
      <Modal 
        show={showAlertModal} 
        onHide={handleCloseAlertModal} 
        centered 
        size="sm"
        backdrop="static"
      >
        <Modal.Header closeButton className="py-2 px-3 bg-warning text-dark">
          <Modal.Title style={{ fontSize: '0.85rem' }} className="fw-bold d-flex align-items-center gap-2">
            <i className="bi bi-exclamation-triangle-fill text-dark"></i> Peringatan
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-3 text-center" style={{ fontSize: '0.8rem' }}>
          <p className="mb-0 fw-medium text-secondary">{alertMessage}</p>
        </Modal.Body>

        <Modal.Footer className="py-1 px-3 bg-light justify-content-center">
          <Button 
            variant="warning" 
            size="sm" 
            className="fw-bold px-4" 
            onClick={handleCloseAlertModal}
            autoFocus
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {/* MODAL HASIL SIMPAN TTB */}
      <Modal
        show={showSaveModal}
        onHide={() => setShowSaveModal(false)}
        centered
        size="md"
        backdrop="static"
      >
        <Modal.Header closeButton className="py-2 px-3 text-white"
          style={{ background: saveLog.failed === 0 ? 'linear-gradient(135deg, #0d9488, #0f766e)' : 'linear-gradient(135deg, #dc2626, #b91c1c)' }}>
          <Modal.Title style={{ fontSize: '0.88rem' }} className="fw-bold d-flex align-items-center gap-2">
            {saveLog.failed === 0
              ? <><i className="bi bi-check-circle-fill"></i> Data Berhasil Disimpan</>
              : <><i className="bi bi-exclamation-circle-fill"></i> Simpan Selesai dengan Error</>
            }
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-3" style={{ fontSize: '0.82rem' }}>
          {/* Ringkasan */}
          <div className="d-flex gap-3 mb-3">
            <div className="flex-fill rounded-2 text-center py-2"
              style={{ background: '#f0fdf4', border: '1px solid #86efac' }}>
              <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#15803d' }}>{saveLog.success}</div>
              <div style={{ fontSize: '0.7rem', color: '#166534' }}>Berhasil</div>
            </div>
            <div className="flex-fill rounded-2 text-center py-2"
              style={{ background: '#fef2f2', border: '1px solid #fca5a5' }}>
              <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#dc2626' }}>{saveLog.failed}</div>
              <div style={{ fontSize: '0.7rem', color: '#991b1b' }}>Gagal</div>
            </div>
          </div>

          {/* Daftar error jika ada */}
          {saveLog.errors.length > 0 && (
            <div>
              <div className="fw-semibold text-danger mb-1" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>Detail Error:
              </div>
              <div className="rounded-2 p-2" style={{ background: '#fff5f5', border: '1px solid #fecaca', maxHeight: '160px', overflowY: 'auto' }}>
                {saveLog.errors.map((err, i) => (
                  <div key={i} className="d-flex align-items-start gap-1 mb-1" style={{ fontSize: '0.72rem', color: '#b91c1c' }}>
                    <i className="bi bi-dot" style={{ flexShrink: 0 }}></i>
                    <span>{err}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {saveLog.failed === 0 && (
            <div className="text-center text-muted mt-1" style={{ fontSize: '0.75rem' }}>
              <i className="bi bi-info-circle me-1"></i>
              Form telah direset dan siap untuk input baru.
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="py-1 px-3 bg-light justify-content-center">
          <Button
            size="sm"
            className="fw-bold px-4 text-white"
            style={{ background: saveLog.failed === 0 ? 'linear-gradient(135deg, #0d9488, #0f766e)' : '#dc2626', border: 'none' }}
            onClick={() => setShowSaveModal(false)}
            autoFocus
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL INPUT DIALOG DATA BARANG - UI MODERN */}

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton className="py-2 px-3 text-white" style={{ background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)' }}>
          <Modal.Title style={{ fontSize: '0.9rem' }} className="fw-bold d-flex align-items-center gap-2">
            <i className="bi bi-box-seam-fill"></i> Input Data Barang Penerimaan
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSaveItem}>
          <Modal.Body className="p-0" style={{ fontSize: '0.8rem' }}>

            {/* ── SEKSI 1: IDENTITAS BARANG ── */}
            <div className="px-3 pt-3 pb-2">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="badge text-white" style={{ background: '#0d9488', fontSize: '0.65rem', letterSpacing: '0.5px' }}>1</span>
                <span className="fw-bold text-uppercase" style={{ fontSize: '0.7rem', color: '#475569', letterSpacing: '0.8px' }}>Identitas Barang</span>
                <hr className="flex-grow-1 my-0 border-secondary opacity-25" />
              </div>
              <Row className="g-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>
                      Kode Barang <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup size="sm">
                      <Form.Control
                        type="text"
                        name="kode"
                        value={newItem.kode}
                        onChange={handleInputChange}
                        placeholder="Klik cari..."
                        required
                        style={formStyles.formControl}
                      />
                      <Button
                        variant="outline-primary"
                        onClick={handleOpenSearchModal}
                        title="Cari Barang via API"
                        style={{ borderColor: '#0d9488', color: '#0d9488', padding: '0.2rem 0.5rem', lineHeight: 1 }}
                      >
                        <i className="bi bi-search" style={{ fontSize: '0.75rem' }}></i>
                      </Button>
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col md={8}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>
                      Nama Barang <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="nama"
                      value={newItem.nama}
                      onChange={handleInputChange}
                      placeholder="Nama barang akan terisi otomatis setelah dicari"
                      required
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            <hr className="my-0 border-secondary opacity-15" />

            {/* ── SEKSI 2: DETAIL FARMASI ── */}
            <div className="px-3 py-2">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="badge text-white" style={{ background: '#0284c7', fontSize: '0.65rem', letterSpacing: '0.5px' }}>2</span>
                <span className="fw-bold text-uppercase" style={{ fontSize: '0.7rem', color: '#475569', letterSpacing: '0.8px' }}>Detail Farmasi</span>
                <hr className="flex-grow-1 my-0 border-secondary opacity-25" />
              </div>
              <Row className="g-2">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>NIE (No. Izin Edar)</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="nie"
                      value={newItem.nie}
                      onChange={handleInputChange}
                      placeholder="DKL1234567890A1"
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>Batch No.</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="batch"
                      value={newItem.batch}
                      onChange={handleInputChange}
                      placeholder="No. Batch"
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>KFA Code</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="kfa"
                      value={newItem.kfa}
                      onChange={handleInputChange}
                      placeholder="KFA..."
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>Tanggal ED</Form.Label>
                    <DatePicker
                      selected={newItem.tglEd}
                      onChange={(date) => setNewItem(prev => ({ ...prev, tglEd: date }))}
                      dateFormat="dd/MM/yyyy"
                      wrapperClassName="w-100"
                      customInput={<CustomDateInput style={formStyles.formControl} />}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>
                      Qty <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      ref={qtyRef}
                      size="sm"
                      type="number"
                      name="qty"
                      value={newItem.qty}
                      onChange={(e) => {
                        handleInputChange(e);
                        if (itemErrors.qty) setItemErrors(prev => ({ ...prev, qty: '' }));
                      }}
                      min="1"
                      style={{
                        ...formStyles.formControl,
                        borderColor: itemErrors.qty ? '#ef4444' : '#cbd5e1',
                        boxShadow: itemErrors.qty ? '0 0 0 2px rgba(239,68,68,0.15)' : 'none'
                      }}
                    />
                    {itemErrors.qty && (
                      <div className="d-flex align-items-center gap-1 mt-1" style={{ color: '#ef4444', fontSize: '0.7rem' }}>
                        <i className="bi bi-exclamation-circle-fill"></i>
                        <span>{itemErrors.qty}</span>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>Satuan</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="satuan"
                      value={newItem.satuan}
                      onChange={handleInputChange}
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            <hr className="my-0 border-secondary opacity-15" />

            {/* ── SEKSI 3: HARGA & KALKULASI ── */}
            <div className="px-3 py-2">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="badge text-white" style={{ background: '#7c3aed', fontSize: '0.65rem', letterSpacing: '0.5px' }}>3</span>
                <span className="fw-bold text-uppercase" style={{ fontSize: '0.7rem', color: '#475569', letterSpacing: '0.8px' }}>Harga & Kalkulasi</span>
                <hr className="flex-grow-1 my-0 border-secondary opacity-25" />
              </div>
              <Row className="g-2 align-items-start">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>
                      Price List (Rp) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      ref={priceListRef}
                      size="sm"
                      type="number"
                      name="priceList"
                      value={newItem.priceList}
                      onChange={(e) => {
                        handleInputChange(e);
                        if (itemErrors.priceList) setItemErrors(prev => ({ ...prev, priceList: '' }));
                      }}
                      style={{
                        ...formStyles.formControl,
                        borderColor: itemErrors.priceList ? '#ef4444' : '#cbd5e1',
                        boxShadow: itemErrors.priceList ? '0 0 0 2px rgba(239,68,68,0.15)' : 'none'
                      }}
                    />
                    {itemErrors.priceList && (
                      <div className="d-flex align-items-center gap-1 mt-1" style={{ color: '#ef4444', fontSize: '0.7rem' }}>
                        <i className="bi bi-exclamation-circle-fill"></i>
                        <span>{itemErrors.priceList}</span>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>Discount (%)</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      name="discPercent"
                      value={newItem.discPercent}
                      onChange={handleInputChange}
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label style={formStyles.formLabel}>PPN (%)</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      name="ppnPercent"
                      value={newItem.ppnPercent}
                      onChange={handleInputChange}
                      style={formStyles.formControl}
                    />
                  </Form.Group>
                </Col>

                {/* Preview Kalkulasi Otomatis */}
                {(() => {
                  const qty = parseFloat(newItem.qty) || 0;
                  const priceList = parseFloat(newItem.priceList) || 0;
                  const discPercent = parseFloat(newItem.discPercent) || 0;
                  const ppnPercent = parseFloat(newItem.ppnPercent) || 0;
                  const discRp = (priceList * discPercent) / 100;
                  const hrgJadi = priceList - discRp;
                  const ppnRp = (hrgJadi * ppnPercent) / 100;
                  const hrgNett = hrgJadi + ppnRp;
                  if (priceList <= 0 || qty <= 0) return null;
                  return (
                    <Col md={12}>
                      <div className="rounded-2 px-3 py-2 mt-1" style={{ background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)', border: '1px solid #86efac' }}>
                        <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between" style={{ fontSize: '0.72rem' }}>
                          <div><span style={{ color: '#6b7280' }}>Hrg Jadi: </span><strong style={{ color: '#15803d' }}>Rp {hrgJadi.toLocaleString('id-ID')}</strong></div>
                          <div><span style={{ color: '#6b7280' }}>Disc: </span><strong style={{ color: '#dc2626' }}>Rp {discRp.toLocaleString('id-ID')}</strong></div>
                          <div><span style={{ color: '#6b7280' }}>PPN: </span><strong style={{ color: '#2563eb' }}>Rp {ppnRp.toLocaleString('id-ID')}</strong></div>
                          <div className="ms-auto">
                            <span style={{ color: '#6b7280' }}>Hrg Nett × {qty}: </span>
                            <strong style={{ color: '#0f766e', fontSize: '0.82rem' }}>Rp {(hrgNett * qty).toLocaleString('id-ID')}</strong>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })()}
              </Row>
            </div>

          </Modal.Body>

          <Modal.Footer className="py-2 px-3" style={{ background: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
            <Button variant="outline-secondary" size="sm" onClick={handleCloseModal} className="px-3">
              <i className="bi bi-x-lg me-1"></i>Batal
            </Button>
            <Button size="sm" type="submit" className="px-3 text-white fw-semibold" style={{ background: 'linear-gradient(135deg, #0d9488, #0f766e)', border: 'none', boxShadow: '0 2px 8px rgba(13,148,136,0.3)' }}>
              <i className="bi bi-save me-1"></i> Simpan ke Tabel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* MODAL PENCARIAN BARANG INTEGRASI API */}
      <Modal show={showSearchModal} onHide={handleCloseSearchModal} size="lg" centered>
        <Modal.Header closeButton className="py-2 px-3 bg-dark text-white">
          <Modal.Title style={{ fontSize: '0.88rem' }} className="fw-bold d-flex align-items-center gap-2">
            <i className="bi bi-search"></i> Pencarian Master Barang
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="p-3">
          <Form onSubmit={handleSearchBarang} className="mb-3">
            <Form.Label style={formStyles.formLabel}>Cari Kode / Nama Barang (kdbrg):</Form.Label>
            <InputGroup size="sm">
              <Form.Control
                type="text"
                placeholder="Ketik nama atau kode barang, contoh: Amoxsan"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                autoFocus
              />
              <Button type="submit" variant="primary" disabled={isLoadingSearch}>
                {isLoadingSearch ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <>
                    <i className="bi bi-search me-1"></i> Cari
                  </>
                )}
              </Button>
            </InputGroup>
          </Form>

          {searchError && (
            <div className="alert alert-danger py-1.5 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
              {searchError}
            </div>
          )}

          <div className="table-responsive rounded-2 border" style={{ maxHeight: '300px' }}>
            <Table hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
              <thead className="table-light sticky-top">
                <tr>
                  <th style={{ width: '100px' }}>Kode</th>
                  <th>Nama Barang</th>
                  <th>Pabrik</th>
                  <th style={{ width: '90px' }}>Satuan</th>
                  <th className="text-center" style={{ width: '70px' }}>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {isLoadingSearch ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4 text-muted">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Memuat data barang...
                    </td>
                  </tr>
                ) : searchResults.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4 text-muted">
                      {searchKeyword ? 'Data barang tidak ditemukan.' : 'Silakan masukkan kata kunci dan klik Cari.'}
                    </td>
                  </tr>
                ) : (
                  searchResults.map((barang, idx) => (
                    <tr key={idx}>
                      <td className="font-monospace fw-semibold">{barang.kode}</td>
                      <td className="fw-medium">{barang.nama}</td>
                      <td className="text-muted">{barang.pabrik}</td>
                      <td>
                        <span className="badge bg-secondary-subtle text-dark border">
                          {barang.satuan}
                        </span>
                      </td>
                      <td className="text-center">
                        <Button 
                          variant="outline-primary" 
                          size="sm" 
                          className="py-0 px-2"
                          style={{ fontSize: '0.72rem' }}
                          onClick={() => handleSelectBarang(barang)}
                        >
                          Pilih
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>

        <Modal.Footer className="py-2 px-3 bg-light">
          <Button variant="secondary" size="sm" onClick={handleCloseSearchModal}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

const styles = {
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#f8fafc',
    color: '#1e293b',
    overflow: 'hidden',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.45rem 1.2rem',
    flexShrink: 0,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.15)',
  },
  navLinkCustom: {
    color: 'rgba(226, 232, 240, 0.75)',
    fontSize: '0.75rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0.4rem 0.75rem',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
  },
  navLinkActive: {
    background: 'rgba(13, 148, 136, 0.3)',
    border: '1px solid rgba(20, 184, 166, 0.4)',
    fontWeight: '600',
    color: '#ffffff',
    boxShadow: '0 2px 8px rgba(13, 148, 136, 0.25)',
  },
  mainContent: {
    flex: 1,
    padding: '1rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflowY: 'auto',
  },
  mainCard: {
    border: 'none',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.02)',
    background: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    padding: '0.65rem 1.2rem',
    color: 'white',
    fontWeight: '600',
    fontSize: '0.85rem',
    letterSpacing: '0.3px',
  },
  bgMenuHeader: { background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)' },
  cardBody: {
    padding: '1.25rem',
  },
};

const formStyles = {
  formLabel: {
    fontSize: '0.68rem',
    fontWeight: '600',
    color: '#334155',
    marginBottom: '0.15rem',
    display: 'block',
    letterSpacing: '0.2px'
  },
  requiredStar: { color: '#ef4444', marginLeft: '1px' },
  formControl: {
    fontSize: '0.72rem',
    borderRadius: '4px',
    padding: '0.2rem 0.35rem',
    border: '1px solid #cbd5e1',
    color: '#2c4043',
    height: 'calc(1.4em + 0.4rem + 2px)'
  },
  formSelect: {
    fontSize: '0.72rem',
    borderRadius: '4px',
    padding: '0.2rem 0.35rem',
    border: '1px solid #cbd5e1',
    color: '#2c4043',
    height: 'calc(1.4em + 0.4rem + 2px)'
  }
};

export default Ttb;